module.exports = __webpack_public_path__ + "img/20180829_125331.402c52db.jpg";